import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
} from "@material-ui/core";
import {
  Button,
  Typography,
  Grid,
  Box,
  TextField,
  MenuItem,
  Alert,
} from "@mui/material";

import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { handleAxiosError } from "../../../../config/action-config";
import { getMeetingDetailsbyId } from "../../../../api/appraisal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
export default function ScheduledMeetingForm() {
  const appraisalData = useSelector((state) => state.appraisalUser);
  const [meetingData, setMeetingData] = useState({});
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getMeetingDetail();
  }, []);
  async function getMeetingDetail() {
    try {
      const { data } = await getMeetingDetailsbyId(params.id, user.token);
      setMeetingData(data.data);
    } catch (err) {
      handleAxiosError(err);
      return { error: true };
    }
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{ display: "flex", justifyContent: "center" }}
      style={{ margin: "35px" }}
    >
      <Paper elevation={5} square={false}>
        <Box style={{ height: "450px", width: "100%" }}>
          <div
            style={{
              marginBottom: "40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} md={6} sm={6} sx={{ m: "10px" }}>
              <Box className="typography-title">
                <Typography variant="h1" className="appraisal-heading-h1">
                  Meeting Scheduled
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={2} md={2} sm={2} sx={{ m: "10px" }}>
              <Button
                size="medium"
                sx={{
                  borderRadius: "10px",
                  fontWeight: "bold",
                  marginLeft: "20px",
                  fontSize: "14px",
                }}
                variant="contained"
                color="inherit"
                onClick={() => navigate("/appraisal")}
              >
                <ArrowBackIosIcon />
                Back
              </Button>
            </Grid>
          </div>
          <Grid
            container
            spacing={3}
            className=""
            sx={{ display: "flex", justifyContent: "center", m: 2, mb: 2 }}
          >
            <Grid item xs={10} md={5} sm={5}>
              <TextField
                fullWidth
                label="Meeting Tittle "
                value={meetingData[0]?.subject || ""}
                disabled
              />
            </Grid>
            <Grid item xs={10} md={5} sm={5}>
              <TextField
                fullWidth
                label="Attendees"
                color="secondary"
                value={meetingData[0]?.attendees || ""}
                disabled
              />
            </Grid>

            <Grid item xs={10} md={10} sm={10}>
              <TextField
                fullWidth
                label="Meeting Start On"
                value={formatDateTime(meetingData[0]?.meeting_start) || ""}
                disabled
                type="text"
              />
            </Grid>

            <Grid item xs={10} md={10} sm={10}>
              <TextField
                fullWidth
                label="Meeting End On "
                value={formatDateTime(meetingData[0]?.meeting_end) || ""}
                type="text"
                disabled
              />
            </Grid>
            <Grid item xs={10} md={5} sm={5}></Grid>
            <Grid item xs={10} md={5} sm={5}></Grid>
          </Grid>
        </Box>
      </Paper>
    </Grid>
  );
}

const formatDateTime = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "UTC",
  };
  return date.toLocaleString("en-GB", options).replace(",", "");
};



